import {Pipe, PipeTransform} from '@angular/core';
import dayjs from "dayjs";

@Pipe({name: 'tagSem', standalone: true, pure: true})
export class TagSemaphorePipe implements PipeTransform {
    transform(value: string | number | Date, now: number | null | undefined) {
        const base = dayjs(now ?? Date.now()).startOf('day');
        let d = typeof value === 'string'
            ? dayjs(value.trim(), ['DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss'], true)
            : dayjs(value);
        if (!d.isValid()) return {};
        const days = base.diff(d.startOf('day'), 'day');
        return {
            'tag-warn': days >= 4 && days <= 9,
            'tag-stop': days >= 10
        };
    }
}
